import React from 'react';
import styled from 'styled-components';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';

const FooterContainer = styled.footer`
  background: #000000;
  color: white;
  padding: 3rem 0 1rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterSection = styled.div`
  h3 {
    color: #FFD700;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }

  p, a {
    color: #bdc3c7;
    text-decoration: none;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    &:hover {
      color: #FFD700;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #FFD700;
  color: #2c1810;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:hover {
    background: #D2691E;
    color: white;
    transform: translateY(-2px);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #34495e;
  padding-top: 1rem;
  text-align: center;
  color: #95a5a6;
  font-size: 0.9rem;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>Poule & Poulette</h3>
          <p>De beste kipgerechten van België</p>
          <p>Al meer dan 20 jaar een begrip in de horeca</p>
          <SocialLinks>
            <SocialLink href="#" aria-label="Facebook">
              <Facebook size={20} />
            </SocialLink>
            <SocialLink href="#" aria-label="Instagram">
              <Instagram size={20} />
            </SocialLink>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <h3>Contact</h3>
          <p>
            <Phone size={16} />
            +32 2 123 45 67
          </p>
          <p>
            <Mail size={16} />
            info@poulepoulette.com
          </p>
          <p>
            <MapPin size={16} />
            Hoofdkantoor: Brussel
          </p>
        </FooterSection>

        <FooterSection>
          <h3>Openingstijden</h3>
          <p>
            <Clock size={16} />
            Maandag - Vrijdag: 11:00 - 22:00
          </p>
          <p>
            <Clock size={16} />
            Zaterdag: 12:00 - 23:00
          </p>
          <p>
            <Clock size={16} />
            Zondag: 12:00 - 21:00
          </p>
        </FooterSection>

        <FooterSection>
          <h3>Snelle Links</h3>
          <p>Menu bekijken</p>
          <p>Online reserveren</p>
          <p>Takeaway bestellen</p>
          <p>Franchise mogelijkheden</p>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <p>&copy; 2024 Poule & Poulette. Alle rechten voorbehouden.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
